import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { Toaster } from 'react-hot-toast';
import axios from 'axios';

// For Create React App environments the variable may be available as
// `process.env.REACT_APP_BASE_API_URL`; we support both for compatibility.
const baseApiUrl = process.env.REACT_APP_BASE_API_URL || 'http://localhost:4275';
axios.defaults.baseURL = baseApiUrl;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
    </AuthProvider>
  </React.StrictMode>
);
